
(function($) {
	

 
    if (window.matchMedia("(max-width: 767px)").matches) {
      // Viewport is less or equal to 700 pixels wide
    } else {
      // Viewport is greater than 700 pixels wide
    }


    $(document).ready(function() {
            if($('.cb-article-product product-card').length > 2){
                $('.cb-article-product').addClass('cb-article-slider');
                $('.cb-article-product').flickity({
                    // options
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    draggable: true
                });
            }
       
    });
})(jQuery);
